/* React base class */
import { Component } from "react"

/* SEO helper */
import { applySeo } from "../helpers"

/* Shared UI components */
import { Block } from "../components"

/* Page PublicOffer */
class PublicOffer extends Component {

    componentDidMount = () => {

        /* SEO */
        applySeo({
            title: "Публичная оферта — Bookify",
            description: "Публичная оферта Bookify — условия использования платформы онлайн-записи для клиентов.",
            path: "/public-offer"
        })

        /* Scroll */
        window.scroll(0, 0)
    }

    render = () => {
        return (
            <Block>
                <div className="page">
                    <div className="legal">

                        <h1>Публичная оферта на использование сервиса Bookify</h1>
                        <p className="legal__updated">Редакция от 1 июля 2026 года</p>

                        <p>Настоящий документ является официальным предложением (публичной офертой) ТОО «SARY GROUP» (далее — «Компания») заключить договор на использование сервиса Bookify на изложенных ниже условиях. Оферта адресована любому дееспособному физическому лицу (далее — «Пользователь»), которое воспользуется сервисом Bookify.</p>

                        <h2>1. Термины и определения</h2>
                        <ul>
                            <li><strong>Сервис Bookify</strong> — мобильное приложение и веб-сайт, предоставляющие возможность онлайн-записи к организациям и мастерам, оказывающим услуги (салоны красоты, барбершопы, автомойки и др.).</li>
                            <li><strong>Организация-партнёр</strong> — юридическое лицо или индивидуальный предприниматель, оказывающие услуги Пользователю и самостоятельно несущие ответственность за их качество.</li>
                            <li><strong>Услуга</strong> — услуга, которую Пользователь бронирует через Сервис и получает непосредственно у Организации-партнёра.</li>
                            <li><strong>Запись (бронирование)</strong> — резервирование Пользователем даты и времени оказания Услуги через Сервис.</li>
                        </ul>

                        <h2>2. Предмет оферты</h2>
                        <p>Компания предоставляет Пользователю доступ к Сервису Bookify для поиска Организаций-партнёров, ознакомления с услугами, ценами и отзывами, а также для онлайн-записи на услуги. Компания является информационным посредником и не оказывает услуги, которые бронируются через Сервис, — их оказывают Организации-партнёры.</p>

                        <h2>3. Акцепт оферты</h2>
                        <p>Акцептом настоящей оферты (полным и безоговорочным принятием её условий) считается регистрация Пользователя в Сервисе и/или оформление записи через Сервис. С момента акцепта договор между Пользователем и Компанией считается заключённым.</p>

                        <h2>4. Стоимость услуг и порядок оплаты</h2>
                        <ul>
                            <li>Использование Сервиса Bookify для поиска организаций и оформления записи является для Пользователя бесплатным.</li>
                            <li>Стоимость самих Услуг устанавливается Организациями-партнёрами и указывается в карточке организации в Сервисе.</li>
                            <li>Все цены в Сервисе указываются, а расчёты (в том числе предоплата за запись, если она предусмотрена Организацией-партнёром) производятся <strong>в национальной валюте Республики Казахстан — казахстанских тенге (₸, KZT)</strong>.</li>
                            <li>Если для подтверждения записи предусмотрена предоплата, её размер и условия отображаются Пользователю до оформления записи. Оплата производится электронными способами, доступными в Сервисе.</li>
                        </ul>

                        <h2>5. Порядок возврата денежных средств</h2>
                        <p>Возврат денежных средств осуществляется в следующем порядке:</p>
                        <ul>
                            <li>Если Пользователь внёс предоплату и отменил запись в сроки, допускающие отмену (указанные в условиях конкретной Организации-партнёра или в Сервисе), предоплата подлежит возврату в полном объёме.</li>
                            <li>При отмене записи Организацией-партнёром либо при неоказании оплаченной Услуги по вине Организации-партнёра внесённые денежные средства возвращаются Пользователю в полном объёме.</li>
                            <li>Для возврата Пользователь направляет обращение в службу поддержки по адресу <a href="mailto:info@bookify.kz">info@bookify.kz</a> с указанием номера записи и реквизитов оплаты. Обращение рассматривается в течение 10 (десяти) рабочих дней.</li>
                            <li>Возврат производится тем же способом и в той же валюте (казахстанских тенге), которыми была произведена оплата. Срок зачисления средств зависит от банка-эмитента и, как правило, составляет до 14 (четырнадцати) рабочих дней с момента одобрения возврата.</li>
                            <li>Денежные средства за фактически оказанную и принятую Пользователем Услугу возврату не подлежат, за исключением случаев ненадлежащего качества, предусмотренных законодательством Республики Казахстан.</li>
                        </ul>

                        <h2>6. Права и обязанности сторон</h2>
                        <ul>
                            <li>Пользователь обязуется предоставлять достоверные данные при регистрации и записи, а также своевременно уведомлять об отмене или переносе записи.</li>
                            <li>Компания обязуется обеспечивать работоспособность Сервиса и обрабатывать персональные данные в соответствии с Политикой конфиденциальности.</li>
                            <li>Компания вправе приостановить доступ к Сервису при нарушении Пользователем условий настоящей оферты.</li>
                        </ul>

                        <h2>7. Ответственность сторон</h2>
                        <p>Ответственность за качество, объём и сроки оказания Услуг несёт Организация-партнёр. Компания не является исполнителем Услуг и не отвечает за действия Организаций-партнёров, но содействует Пользователю в урегулировании спорных ситуаций. Компания не несёт ответственности за перебои в работе Сервиса, вызванные обстоятельствами непреодолимой силы или действиями третьих лиц.</p>

                        <h2>8. Урегулирование споров и применимое право</h2>
                        <ul>
                            <li>Все споры и разногласия, возникающие в связи с использованием Сервиса, стороны стремятся разрешить путём переговоров. Претензия направляется на адрес <a href="mailto:info@bookify.kz">info@bookify.kz</a> и рассматривается в течение 15 (пятнадцати) рабочих дней с момента получения.</li>
                            <li>Если спор касается качества Услуги, Компания оказывает содействие во взаимодействии между Пользователем и Организацией-партнёром.</li>
                            <li>При недостижении согласия спор подлежит разрешению в судебном порядке по месту нахождения Компании.</li>
                            <li>Настоящая оферта и все отношения сторон регулируются и толкуются в соответствии с действующим <strong>законодательством Республики Казахстан</strong>.</li>
                        </ul>

                        <h2>9. Срок действия и изменение условий</h2>
                        <p>Оферта вступает в силу с момента её размещения в Сервисе и действует бессрочно до её отзыва Компанией. Компания вправе в одностороннем порядке изменять условия оферты, публикуя новую редакцию в Сервисе. Продолжение использования Сервиса после внесения изменений означает согласие Пользователя с новой редакцией.</p>

                        <h2>10. Реквизиты Компании</h2>
                        <ul>
                            <li><strong>ТОО «SARY GROUP»</strong></li>
                            <li><strong>БИН:</strong> 240440023071</li>
                            <li><strong>Email:</strong> <a href="mailto:info@bookify.kz">info@bookify.kz</a></li>
                            <li><strong>Телефон:</strong> +7 (707) 138-51-00</li>
                            <li><strong>Адрес:</strong> Казахстан, г. Алматы, микрорайон Мамыр 1, 26, БЦ Quorum, 508 кабинет</li>
                        </ul>

                    </div>
                </div>
            </Block>
        )
    }
}

export default PublicOffer
